import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";

const IntervalHistory = () => {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    fetch("/api/interval-history")
      .then((res) => res.json())
      .then((data) => setHistory(data))
      .catch((err) => console.error("Failed to load interval history", err));
  }, []);

  const exportCSV = () => {
    const csv = [
      ["Device ID", "Old Interval", "New Interval", "Timestamp", "Username"],
      ...history.map((h) => [
        h.deviceId,
        h.oldInterval,
        h.newInterval,
        new Date(h.timestamp).toLocaleString("en-US", { timeZone: "America/Chicago" }),
        h.username,
      ]),
    ]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "interval_history.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{ display: "flex", background: "#eee", minHeight: "100vh" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "2rem" }}>
        <h2 style={{ marginBottom: "1rem" }}>Interval Change History</h2>

        <button
          onClick={exportCSV}
          style={{
            backgroundColor: "#28a745",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            float: "right",
            marginBottom: "1rem",
          }}
        >
          ⬇ Export CSV
        </button>

        <table style={{ width: "100%", background: "#fff", borderRadius: "10px" }}>
          <thead>
            <tr style={{ background: "#ddd" }}>
              <th>Device ID</th>
              <th>Old Interval</th>
              <th>New Interval</th>
              <th>Timestamp</th>
              <th>Username</th>
            </tr>
          </thead>
          <tbody>
            {history.map((h, i) => (
              <tr key={i}>
                <td>{h.deviceId}</td>
                <td>{h.oldInterval} min</td>
                <td>{h.newInterval} min</td>
                <td>
                  {new Date(h.timestamp).toLocaleString("en-US", {
                    timeZone: "America/Chicago",
                  })}
                </td>
                <td>{h.username}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IntervalHistory;
